export const SETTING_CAROUSEL = {
  arrows: true,
  infinite: true,
  initialSlide: 0,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  swipeToSlide: true,
  autoplay: true,
  autoplaySpeed: 2000,
  pauseOnFocus: true,
  pauseOnHover: true
};
